export default __webpack_public_path__ + "static/media/after.13bb8973.png";